// extracted by mini-css-extract-plugin
export default {"DetailsListComponent":"DetailsListComponent_snTki"};